export default __webpack_public_path__ + "static/media/EVENT26ASTACK.597bb85c.png";